import React from 'react'
import { connect } from 'react-redux'

import { ReactModal } from '../../../../../components'
import { MODAL, ORDER } from '../../../../../reduxs'
import { EXTEND_MEETING, ORDER_MODAL_ACTION_TEXT } from '../../../../../helpers'

import { ExtendModalStyle } from './styles'

function ExtendMeetingModal(props) {
  const {
    language,
    colorTheme,
    closeExtendMeetingModal,
    isOpenExtendMeetingModal,
    contentExtendModal,
    onClickExtend,
    setTextSuccess,
  } = props

  const handleBackToInfo = () => {
    closeExtendMeetingModal()
  }

  const handleSubmitExtendMeeting = () => {
    closeExtendMeetingModal()
    onClickExtend()
    setTextSuccess()
  }


  return (
    <ReactModal isVisible={isOpenExtendMeetingModal} width={440} borderRadius={8}>
      <ExtendModalStyle colorTheme={colorTheme}>
        <div className='container-modal'>
          <h2 className='confirm-order__title'>
            {EXTEND_MEETING.HEADER[language]}
          </h2>
          <div className='confirm-order__list'>
            {EXTEND_MEETING.CONTENT[language]}
          </div>
          {contentExtendModal}
        </div>
        <div className='confirm-order__button'>
          <button
            className='confirm-order__button--back'
            onClick={() => handleBackToInfo()}
          >
            {ORDER_MODAL_ACTION_TEXT.BACK[language]}
          </button>
          <button
            className='confirm-order__button--confirm'
            onClick={() => handleSubmitExtendMeeting()}
          >
            {EXTEND_MEETING.BUTTON_EXTEND[language]}
          </button>
        </div>
      </ExtendModalStyle>
    </ReactModal>
  )
}

const mapStateToProps = ({ orderReducer, accountReducer, modalReducer }) => {
  return {
    confirmItems: orderReducer.confirmItems,
    colorTheme: accountReducer.user.colorThemePalette,
    isOpenExtendMeetingModal: modalReducer.isOpenExtendMeetingModal,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeExtendMeetingModal: () => dispatch(MODAL.action.closeExtendMeetingModal(false)),
    setTextSuccess: () => dispatch(ORDER.action.setOrderActionText('SUCCESS', 'SUCCESS')),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExtendMeetingModal)
